import React from 'react';
import UnifiedTagEditor from './unified-tag-editor';

const NonProductTagEditor: React.FC = () => {
  return (
    <UnifiedTagEditor
      mode="tags"
      layout="cards"
      title="Tags"
      emptyMessage="No tags have been created yet. Click 'Add New Tag' to create your first tag."
      addButtonText="Add New Tag"
      nameLabel="Tag Name"
      descriptionLabel="Description"
    />
  );
};

export default NonProductTagEditor;
